import ReadMore, { ReadMoreProps } from './ReadMore';

export type { ReadMoreProps };
export default ReadMore;
